import { Component, OnInit, ElementRef, ViewChild, TemplateRef, Renderer2 } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DataTablesResponse } from '../shared/models/datatables-response';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../environments/environment'
import { User1031ListOutputModel } from '../shared/models/User1031ListOutputModel';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { CommonService } from '../shared/providers/common.service';
import { ToastService } from '../shared/providers/toast.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { IBroker } from '../shared/models/BrokerListOutputModel';
import { IBrokerInput } from '../shared/models/BrokerInputModel';
import { Trade1031Service } from '../shared/providers/Trade1031.service';
import { ValidationService } from '../shared/providers/validation.service';
import { LoaderService } from '../shared/providers/loader.service';
import { IExchangeInvitesList } from '../shared/models/DashboardDataOModel';
import { IPropertyAccessInputModel } from '../shared/models/PropertyAccessInputModel';
import { UserManagerService } from '../shared/providers/user-manager.service';
import { YesNo } from '../shared/enum/enum';
import { ITrade1031InputModel } from '../shared/models/Trade1031InputModel';
import { RestService } from '../shared/providers/rest.service';
import { IExchangeCodeOutputModel, IExchangeDetailsputModel } from '../shared/models/ExchangeCodeOutputModel';
import { SharedService } from '../shared/providers/shared.service';
import { IPropertyChatModel } from '../shared/models/PropertyChatModel';
import { IBrokerList } from '../shared/models/BrokerList';
import { IDateTimeModel } from '../shared/models/ExchangePropertyStatusInputModel';
import { catchError, debounceTime, distinctUntilChanged, filter, Observable, of, Subject, switchMap, tap } from 'rxjs';
export enum Status {
  New = 2152,
  Assigned = 2153,
  Rejected = 2154,
  Reset = 0,
}
enum Tabs {
  Active = 1,
  InActive = 2,
}

@Component({
  selector: 'exchange-list',
  templateUrl: './1031exchange-list.component.html',
  styleUrls: ['./1031exchange-list.component.css']
})

export class User1031ExchangeListComponent implements OnInit {
  protected readonly BASE_URL: string = environment.base_url;
  dtOptions = {};
  table: DataTableDirective;
  users: User1031ListOutputModel[];
  cnt: any;
  statusList: ILookUp[];
  modalRef: BsModalRef;
  selectedInquiryId: number;
  currentIndex: number;
  brokersId: number;
  IsLoading: boolean = false;
  exchange: any;
  brid: any;
  user: any;
  status = Status;
  isAdmin: boolean;
  IsPrincipal = false;
  hideAssignbtn: boolean = false;
  statusId: number = 0;
  newCount: number;
  assignedCount: number;
  rejectedCount: number;
  dateModel = {} as IDateTimeModel;
  //isProcessing: boolean;
  usersCount: number = 0;
  exchangeBrokersIdList: any = [];
  currentMenu = '';
  selectedExchange: number = 0;
  UnReadMessageCount: number = 0;
  viewMessageIcon: boolean = false;
  propertyChatModel = {} as IPropertyChatModel;
  tabs = Tabs;
  activeTab = Tabs.Active;
  dtTrigger = new Subject();
  searchTerm: string;
  //defaultBrokerText: IMultiSelectTexts = {
  //  checked: 'item selected',
  //  checkedPlural: 'items selected',
  //  defaultTitle: 'Select Brokers',
  //  searchEmptyResult: 'No results found...',
  //};
  defaultBrokerSettings = {
    singleSelection: false,
    text: "Select Brokers",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "myclass custom-class",
    enableFilterSelectAll: false,
  };

  //defaultBrokerSettings = {
  //  enableSearch: true,
  //  dynamicTitleMaxItems: 1,
  //  displayAllSelectedText: true,
  //  buttonClasses: 'btn btn-default btn-block',
  //};
  isEditAllowed = true;
  previousSelectedLastName = "";
  isFromAutoComplete = false;

  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  dataService$: Observable<any[]>;
  dataServiceInput$ = new Subject<string>();
  loading = false;

  constructor(private modalService: BsModalService, private renderer: Renderer2,
 private http: HttpClient, public authService: AuthenticationService,
    private router: Router, private _toastService: ToastService, private _commonService: CommonService, private _Trade1031Service: Trade1031Service,
    private Toast: ToastService, public Validation: ValidationService, private Loader: LoaderService, private activatedRoute: ActivatedRoute, private _userManagerService: UserManagerService, private _restService: RestService,
    private Shared: SharedService) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let fromMenu = params['fromMenu'];
      if (fromMenu !== null && fromMenu !== undefined) {
        this.currentMenu = fromMenu;
      }
      if (this.Validation.IsValid(params["activetab"])) {
        this.activeTab = parseInt(params["activetab"]);
      }
    });

    //const remoteDataProvider = completerService.remote(_restService.getBaseUrl + '/common/GetPrincipalWithoutExchangeByAutoComplete/', 'Name', 'Name');
    //remoteDataProvider.urlFormater(x => {
    //  return encodeURI(_restService.getBaseUrl + '/common/GetPrincipalWithoutExchangeByAutoComplete/' + x);
    //});

    //this.dataService = remoteDataProvider;

    this.loadItems()
  }

  onSearchBlur(event: any) {
    if (this.exchangeInputModel.firstname == null || this.exchangeInputModel.firstname == "") {
      if (this.searchTerm != null && this.searchTerm != "") {
        this.exchangeInputModel.firstname = this.searchTerm;
      }
      // You can manually retain the search value here if necessary
    }
  }

  private loadItems() {
    this.dataService$ = this.dataServiceInput$.pipe(
      distinctUntilChanged(),
      debounceTime(400),
      tap(() => this.loading = true),
      switchMap(term => this.getItems(term).pipe(
        catchError(() => of([])), // empty list on error
        tap(() => this.loading = false)
      ))
    )
  }

  getItems(term: any = null): Observable<any[]> {
    return this._commonService.getPrincipalWithoutExchangeByAutoComplete(term);

  }

  // getPrincipalNames(term: any = null): void {
  //   let items = [];
  //   this._commonService.getPrincipalWithoutExchangeByAutoComplete(term).subscribe(res => {
  //     this.dataService = res.map(o => {
  //       return {
  //         Id: o.Id, Name: o.Name, FirstName: o.FirstName, LastName: o.LastName, Email: o.Email, Phone: o.Phone
  //       };
  //     });
  //   });


  // }

  brokers: IBroker[];
  broker = {} as IBroker;
  brokersNewExchange: IBroker[];
  brokersSelected: IBroker[];
  brokersSelectedNewExchange: IBroker[];
  BrokerInput = {} as IBrokerInput;
  BrokerInputNewExchange = {} as IBrokerInput;
  Status = Status;
  brokerlist: IBrokerList[];
  validationMsg: boolean = false;
  IsDemoEnv = false;


  popupheader = "Add Broker";
  loggedinUserId = 0;
  principalId = 0;
  brokerId = 0;
  activefilterButton = 0;
  isBroker = false;
  exchangeInputModel = {} as ITrade1031InputModel;
  rowCount = 0;
  ipAddress: string;
  ngOnInit() {
    this.user = this.authService.user;
    this.loadExchangeList();
    this._Trade1031Service.IsDemoEnv().subscribe((res: boolean) => {
      this.IsDemoEnv = res;
    });

    // this.loadItems();

  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
    this.bindBroker();
  }

  loadExchangeList() {
    var loggedinUserId = this.user.Id;
    // this.role = this.user.Role;
    const that = this;
    this.isAdmin = false;
    this.isBroker = false;

    let defaultSort = 6;

    let TableColums =
      [{ data: 'ID' }, { data: 'ID' },
      { data: 'Buyer' },
      { data: 'ProjectedSaleDate' },
      { data: 'DaysLeft' },
      { data: 'CreatedDate' },
      { data: 'RecentActivityDate' },
      { data: 'OfferCount' }
      ];

    if (this.authService.Admin() || this.authService.SuperAdmin()) {
      this.loggedinUserId = 0
      this.isAdmin = true;
      defaultSort = 6;
      TableColums =
        [{ data: 'ID' }, { data: 'ID' },
        { data: 'Buyer' },
        { data: 'ProjectedSaleDate' },
        { data: 'DaysLeft' },
        { data: 'CreatedDate' },
        { data: 'RecentActivityDate' },
        { data: 'OfferCount' },
        { data: 'BrokerAssigned' }
        ];
    }
    if (this.authService.Principal() || this.authService.Principal1031()) {
      this.viewMessageIcon = true;
      this.loggedinUserId = this.user.Id;
      this.principalId = this.loggedinUserId;
      this.IsPrincipal = true;
      defaultSort = 6;
      TableColums =
        [{ data: 'ID' }, { data: 'ID' },
        { data: 'ProjectedSaleDate' },
        { data: 'DaysLeft' },
        { data: 'CreatedDate' },
        { data: 'RecentActivityDate' },
        { data: 'OfferCount' },
        { data: 'BrokerAssigned' },
        { data: 'Proceeds' }
        ];
    }
    else if (this.authService.Broker()) {
      this.isBroker = true;
      this.viewMessageIcon = true;
      this.loggedinUserId = this.user.Id;
      this.brokerId = this.loggedinUserId;
    }

    const filter =
    {
      BrokerId: this.brokerId,
      PrincipalId: this.principalId,

    }

    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "pageLength": 50,
      "order": [[defaultSort, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: async (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true
        dataTablesParameters.Extra_param = filter;
        dataTablesParameters.Extra_param.StatusId = this.statusId;
        dataTablesParameters.Extra_param.ActiveStatus = this.activeTab
        dataTablesParameters.Extra_param.Source='Exchange'
        const httpHeader = this.Validation.GetAuthHeader();
        that.http
          .post<DataTablesResponse>(
            await this.BASE_URL + '/opportunity/user1031list/' + loggedinUserId,
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.users = resp.data ? resp.data : [];

            this.usersCount = that.users.length;
            this.rowCount = resp.recordsTotal;
            //if (that.users.length > 0) {
            //  this.newCount = this.users[0].CtNewCount;
            //  this.assignedCount = this.users[0].CtAssignedCount;
            //  this.rejectedCount = this.users[0].CtRejectedCount;
            //}
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;
          });
      },
      columns: TableColums
    };

  }
  exchangeCodes: IExchangeCodeOutputModel[];
  exchangeDetails = {} as IExchangeDetailsputModel;
  onBuyerSelect($event) {
    if ($event != null && $event.Name!=undefined&&$event.Name) {
      this.exchangeInputModel.userid = $event.Id;
      this.exchangeInputModel.firstname = $event.FirstName;
      this.exchangeInputModel.lastname = $event.LastName;
      this.exchangeInputModel.email = $event.Email;
      this.exchangeInputModel.phone = $event.Phone;
      this.isEditAllowed = false;
      this.previousSelectedLastName = this.exchangeInputModel.firstname;
      this.isFromAutoComplete = true;
    }
    else {
      this.isFromAutoComplete = false;
    }
  }
  onFirstnameChange($event) {
    const inputValue = (event.target as HTMLInputElement).value;
    this.searchTerm = inputValue;
    this.exchangeInputModel.firstname = null;
    if (this.Validation.IsinValid(this.exchangeInputModel.firstname) || (this.isFromAutoComplete && this.previousSelectedLastName.trim() != this.exchangeInputModel.firstname.trim())) {
      this.exchangeInputModel.userid = null;
      this.exchangeInputModel.lastname = null;
      this.exchangeInputModel.email = null;
      this.exchangeInputModel.phone = null;
      $("#txtphone").val("");
      this.isEditAllowed = true;
    }
  }
  initializeModel() {
    this.isSubmit = false;
    this.exchangeInputModel.userid = null;
    this.exchangeInputModel.firstname = null;
    this.exchangeInputModel.lastname = null;
    this.exchangeInputModel.email = null;
    this.exchangeInputModel.phone = null;
    this.exchangeInputModel.totalsaleprice = null;
    this.exchangeInputModel.sold_projectedsaledate = null;
    this.brokersSelectedNewExchange = [];
    this.isEditAllowed = true;
  }
  allBrokers: IBroker[];
  async bindBroker() {
    await this._commonService.getBrokersNames().subscribe(response => {
      if (response != null && response.length > 0) {
        this.brokers = response.map(o => { return { id: o.LeadContactId, name: o.BrokerName } });
        this.brokersNewExchange = this.brokers;
        this.allBrokers = this.brokers;
        this.brokerlist = response.map(p => { return { Id: p.LeadContactId, Name: p.BrokerName, Email: p.Email, Phone: p.Phone, PhotoPath: p.PhotoPath, Date: p.Date, Status: p.Status, IsPrimaryAgent: false, IsExistingBroker: "" } });
      }
    });
  }
  viewDetail(exguid: any) {
    //this.router.navigate(['/exchange1031-view/' + exguid]);
    this.router.navigate(['/dashboard-1031/' + exguid], { queryParams: { activeTab: this.activeTab } });
  }

  viewStatusDetail(idstatus: any, loggedinUserId: any) {
    this.activefilterButton = idstatus;
    this.statusId = idstatus;
    this.loggedinUserId = loggedinUserId;
    this.dtElement.dtInstance.then(x => x.draw());
  }
  convertUTCDateToLocalDateSale(ProjectedSaleDate: Date) {
    var newDate = new Date(ProjectedSaleDate);
    var offset = newDate.getTimezoneOffset() / 60;
    var offsetTime = new Date(newDate.getTime() - (offset * 60 * 1000 * 60));
    return offsetTime;
  }

  onSearch(text: string) {

    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }
  assignedBrokerCount = 0;
  ExchangeInvitesList: IExchangeInvitesList[];

  openModal(template: TemplateRef<any>, classes: any, exchangeid) {
    this.assignedBrokerCount = 0;
    this.exchange = this.users;
    this.brokersSelected = [];
    this.validationMsg = false;
    this.brokers = this.allBrokers;
    this.currentExchangeid = exchangeid;

    this._Trade1031Service.GetExchangeBrokers(exchangeid).subscribe(res => {
      this.exchangeBrokersIdList = [];
      this.ExchangeInvitesList = res;
      if (res.length > 0) {
        res.forEach(item => {
          this.exchangeBrokersIdList.push(item.Id);
          this.assignedBrokerCount++;
        });

        if (this.exchangeBrokersIdList != undefined && this.exchangeBrokersIdList.length > 0) {
          var exchangeBrokers = this.exchangeBrokersIdList;
          this.brokers = this.brokers.filter(function (emp) {
            return exchangeBrokers.indexOf(emp.id) == -1;
          });
        }
      }
    });
    //setTimeout(() => {
    //    if (this.exchangeBrokersIdList != undefined && this.exchangeBrokersIdList.length > 0) {
    //        var exchangeBrokers = this.exchangeBrokersIdList;
    //        this.brokers = this.brokers.filter(function (emp) {
    //            return exchangeBrokers.indexOf(emp.id) == -1;
    //        });
    //    } 
    //}, 1000);     
    this.BrokerInput.Id = exchangeid;
    this.modalRef = this.modalService.show(template, { class: classes });
    this.hideAssignbtn = false;
  }

  searchText = '';
  saveBroker() {
    this.hideAssignbtn = true;
    if (this.brokersSelected.length >= 0) {
      let count = 0;
      this.brokersSelected.forEach(item => {
        count++;
        const index: number = this.brokersSelected.indexOf(item);
        if (index == 0) {
          this.BrokerInput.BrokerId = Number(item);
          this.BrokerInput.LoggedInUserId = this.user.Id;
          this._Trade1031Service.Save1031Broker(this.BrokerInput).subscribe(response => {
            if (count == this.brokersSelected.length) {
              this.reloadList();
            }
            //if (response) {
            //    this.Toast.addToast({ title: 'Success', msg: 'Broker assigned Successfully', timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
            //    this.modalRef.hide();
            //    this.dtElement.dtInstance.then(x => x.draw());
            //    this.hideAssignbtn = false;
            //    this.brokersSelected = [];
            //}
            //else {
            //    this.Toast.addToast({ title: 'Error Occurred', timeout: 3000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
            //    this.hideAssignbtn = false;
            //}
          });
        }
        else {
          this.BrokerInput.AssignedAgentId = Number(item);
          this._Trade1031Service.SaveExchangeAssociate(this.BrokerInput).subscribe(response => {
            if (count == this.brokersSelected.length) {
              this.reloadList();
            }
            //if (response) {
            //    this.Toast.addToast({ title: 'Success', msg: 'Broker assigned Successfully', timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
            //    this.modalRef.hide();
            //    this.dtElement.dtInstance.then(x => x.draw());
            //    this.hideAssignbtn = false;
            //}
            //else {
            //    this.Toast.addToast({ title: 'Error Occurred', timeout: 3000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
            //    this.hideAssignbtn = false;
            //}
          });
        }

      });
    }
    else {
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least one broker', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      this.hideAssignbtn = false;
    }

  }

  reloadList() {
    this.Toast.addToast({ title: 'Success', msg: 'Broker assigned Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
    this.modalRef.hide();
    this.dtElement.dtInstance.then(x => x.draw());
    this.hideAssignbtn = false;
    this.brokersSelected = [];
  }

  currentExchangeid = 0;
  statusToChange = 0;
  statusName = '';
  OnChangestatus(template: TemplateRef<any>, classes: any, exchangeid, status, statusName) {
    this.currentExchangeid = exchangeid;
    this.statusToChange = status;
    this.statusName = statusName;
    this.modalRef = this.modalService.show(template, { class: classes });
  }
  ChangeInquirystatus() {
    this._Trade1031Service.Update1031InquiryStatus(this.currentExchangeid, this.statusToChange).subscribe(response => {
      if (response) {
        this.Toast.addToast({ title: 'Success', msg: 'Inquiry Status Changed Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
      this.dtElement.dtInstance.then(x => x.draw());
    });
  }
  openMessageTab(template: TemplateRef<any>, classes, exchange) {
    var openModelStatus = true;
    exchange.UnReadMessageCount = 0;
    if (openModelStatus) {
      if (exchange.ID != "") {
        this.selectedExchange = exchange.ID;
        this.propertyChatModel.ExchangeId = this.selectedExchange;
        this.propertyChatModel.PropertyGuid = null;
        this.Shared.clickMessage(this.propertyChatModel);

      }
    }
  }
  accessModel = {} as IPropertyAccessInputModel;
  grant1031Access() {
    this.Loader.display(true);
    this._userManagerService.update1031access(this.accessModel).subscribe(response => {
      if (response) {
        this.accessModel = {} as any;

        this._toastService.addToast({ title: 'Success', msg: 'You have successfully changed the 1031 access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        this.dtElement.dtInstance.then(x => x.draw());
      }
      else {
        this.accessModel = {} as any;

        this._toastService.addToast({ title: 'Error', msg: 'An error Occurred while changing the 1031 access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }

      this.modalRef.hide();
      this.Loader.display(false);

    });
  }

  private addClassToOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.addClass(overlayContainer, 'custom-overlay-container');
    }
  }

  grant1031AccessConfirmation(userguid, event, template: TemplateRef<any>, classes: any) {
    this.accessModel.Is1031EnabledId = event.target.checked ? YesNo.Yes : YesNo.No;
    this.accessModel.UserId = userguid;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  grant1031DashboardAccess(userguid, event, id) {
    let status = event.target.checked;
    this._userManagerService.Change1031DashboardAccess(userguid, status, id).subscribe(response => {
      if (response) {
        this._toastService.addToast({ title: 'Success', msg: 'You have successfully changed the 1031 dashboard access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
      }
      else {
        this._toastService.addToast({ title: 'Error', msg: 'An error Occurred while changing the 1031 dashboard access status', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    });
  }
  openCreateExchangeModel(template: TemplateRef<any>) {
    this.getIpAddress();
    this.initializeModel();
    this.brokersNewExchange = this.allBrokers;
    this.modalRef = this.modalService.show(template, { class: 'panlestyle' });
  }

  async getIpAddress() {
    await this.Validation.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }
  saveDemoDate() {
    this.dateModel.CurrentDate = new Date();
    this._Trade1031Service.SaveDemoDate(this.dateModel).subscribe(res => {
      this._toastService.addToast({ title: 'Success', msg: 'Date Updated Successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });

    });
  }

  isSubmit = false;
  submitInquiry() {
    this.isSubmit = true;
    let valid = true;

    if (this.Validation.IsinValid(this.exchangeInputModel.firstname) ||
      this.Validation.IsinValid(this.exchangeInputModel.lastname) ||
      this.Validation.IsinValid(this.exchangeInputModel.email) ||
      this.Validation.IsinValid(this.exchangeInputModel.phone)
      //||
      //this.Validation.IsinValid(this.exchangeInputModel.totalsaleprice) ||
      //this.Validation.IsinValid(this.exchangeInputModel.sold_projectedsaledate) ||
      //(this.brokersSelectedNewExchange.length <= 0)
    ) {
      valid = false;
    }
    else if (!this.Validation.isEmail(this.exchangeInputModel.email)) {
      valid = false;
    }
    else if (!this.Validation.isPhoneNumber(this.exchangeInputModel.phone)) {
      valid = false;
    }
    //else if (!this.Validation.IsDate(this.exchangeInputModel.sold_projectedsaledate)) {
    //    valid = false;
    //}

    if (valid) {
      //this._auth0.createUserAndGenerateResetPassword(this.exchangeInputModel.email).subscribe(res => {
      //    debugger
      this.saveInquiry(valid);
      //})
      //this._auth0.auth0SearchUserByEmailId(this.exchangeInputModel.email).subscribe(res => {
      //    res.subscribe(item => {  
      //        
      //        if (item.length == 0) {
      //            this._auth0.auth0CreateUser(this.exchangeInputModel.email, environment.auth0.defaultPassword, false).subscribe(res => {
      //                res.subscribe(res => {
      //                                                    
      //                    if (res["user_id"]) {
      //                        this._auth0.gerateUserResetPasswordLink(res["user_id"]).subscribe(res => {
      //                            res.subscribe(res => {
      //                                this.saveInquiry(valid, res["ticket"]);
      //                            })
      //                        })
      //                    }
      //                })
      //            });
      //        }
      //        else {
      //            this.saveInquiry(valid, res["ticket"]);
      //        }
      //    })
      //}) 
    }
  }

  saveInquiry(valid) {
    if (valid) {
      this.Loader.display(true);

      if (this.exchangeInputModel.sold_projectedsaledate && this.Validation.IsDate(this.exchangeInputModel.sold_projectedsaledate)) {
        this.exchangeInputModel.sold_projectedsaledate = this.Validation.utcify(this.exchangeInputModel.sold_projectedsaledate);
      }
      //this.exchangeInputModel.userid = null;
      this.exchangeInputModel.isGuestUser = false;
      this.exchangeInputModel.IsAdminCreatedExchange = true;
      this.exchangeInputModel.IPAddress = this.ipAddress;
      this.exchangeInputModel.loggedinUserId = this.user.Id
      this.exchangeInputModel.brokers = this.brokersSelectedNewExchange;

      this._Trade1031Service.Save1031Trade(this.exchangeInputModel).subscribe(res => {
        if (res["IsSuccess"] == true) {
          let currentGuid = res["CurrentGuid"];
          this.BrokerInputNewExchange.Exchange1031Guid = currentGuid;

          if (this.brokersSelectedNewExchange.length > 0) {
            let count = 0;
            this.brokersSelectedNewExchange.forEach(item => {
              count++;
              const index: number = this.brokersSelectedNewExchange.indexOf(item);
              if (index == 0) {
                this.BrokerInputNewExchange.BrokerId = Number(item);
                this.BrokerInput.LoggedInUserId = this.user.Id;
                this._Trade1031Service.Save1031Broker(this.BrokerInputNewExchange).subscribe(response => {
                  if (count == this.brokersSelectedNewExchange.length) {
                    this.resetForm();
                  }
                });
              }
              else {
                this.BrokerInputNewExchange.AssignedAgentId = Number(item);
                this._Trade1031Service.SaveExchangeAssociate(this.BrokerInputNewExchange).subscribe(response => {
                  if (count == this.brokersSelected.length) {
                    this.resetForm();
                  }
                });
              }
            });
          }
          else {
            this.resetForm();
          }
        }
        else {
          this.Loader.display(false);
          this._toastService.addToast({ title: 'Error Occurred', msg: res["ErrorMessage"], timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
        }
      });
    }
  }

  resetForm() {
    this.initializeModel();
    this.modalRef.hide();
    this.dtElement.dtInstance.then(x => x.draw());
    this._toastService.addToast({ title: 'Success', msg: 'Exchange created successfully.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
    this.Loader.display(false);
  }

  brokerAssigned_3(currentBrokers: string) {
    let brokersToDisplay = ''
    if (currentBrokers) {
      let brokers = currentBrokers.split(',');
      let count = 0;
      brokers.forEach(item => {
        if (count < 3) {
          brokersToDisplay += item + ",";
        }
        count++;
      });
      brokersToDisplay = brokersToDisplay.slice(0, -1);
    }
    return brokersToDisplay;
  }

  brokerAssigned_others(currentBrokers: string) {
    let brokersToDisplay = ''
    if (currentBrokers) {
      let brokers = currentBrokers.split(',');
      let count = 0;
      brokers.forEach(item => {
        if (count > 2) {
          brokersToDisplay += item + ",";
        }
        count++;
      });
      brokersToDisplay = brokersToDisplay.slice(0, -1);
    }
    return brokersToDisplay;
  }

  brokerAssigned_count(currentBrokers: string) {
    let count = 0;
    let displayCount = 0;
    if (currentBrokers) {
      let brokers = currentBrokers.split(',');
      brokers.forEach(item => {
        if (count > 2) {
          displayCount++;
        }
        count++;
      });
    }
    return displayCount;
  }

  cancelConfirmation() {
    this.Loader.display(true);
    this.dtElement.dtInstance.then(x => x.draw());
    this.modalRef.hide();
  }

  @ViewChild('Confirmation') Confirmation: TemplateRef<any>;
  @ViewChild('DeleteModal') DeleteModal: TemplateRef<any>;
  userIdToSendLink = 0;
  sendToUserLink = '';
  modalRefConfirmation: BsModalRef;
  modalDeleteBroker: BsModalRef;
  openConfirmSendLink(userid) {
    this.userIdToSendLink = userid;
    this.sendToUserLink = '';
    let selecteduser = this.users.find(x => x.UserId == userid);
    this.sendToUserLink = selecteduser.Buyer + ' (' + selecteduser.Email + ')';
    this.modalRefConfirmation = this.modalService.show(this.Confirmation, { class: 'deletemodal' });
  }
  SendLinkToEBRA() {
    this.Loader.display(true);
    this._Trade1031Service.SendLinkToEBRA(this.userIdToSendLink).subscribe(response => {
      if (response) {
        this.modalRefConfirmation.hide();
        let selecteduser = this.users.find(x => x.UserId == this.userIdToSendLink);
        selecteduser.IsEBRALinkSent = true;
        selecteduser.EBRASendDate = new Date();
        //this.dtElement.dtInstance.then(x => x.draw());

        this.Toast.addToast({
          title: 'Success', msg:
            'Invite sent successfully', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
        });
      }
      else {
        this.Toast.addToast({
          title: 'Error', msg:
            'Error sending invites', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
        });
      }
      this.Loader.display(false);
    });
  }

  addBrokerToList() {
    // Whenever we are adding a new Broker to the list we will be keeping it in I status (I -> Insert)
    if (this.brokersSelected.length >= 0) {
      this.brokersSelected.forEach(item => {
        var details = this.brokerlist.find(x => x.Id == Number(item));
        details.IsExistingBroker = "I";
        if (this.ExchangeInvitesList.length == 0) {
          details.IsPrimaryAgent = true;
        }
        else {
          details.IsPrimaryAgent = false;
        }
        this.ExchangeInvitesList.push(details);
        var index = this.brokers.findIndex(x => x.id == Number(item));
        this.brokers.splice(index, 1);
        this.brokers = [...this.brokers]; // For forcefull refresh of the model
        this.validationMsg = false;
      });
      this.assignedBrokerCount = this.ExchangeInvitesList.length;
      this.brokersSelected = [];
    }
    else {
      this._toastService.addToast({ title: 'Error Occurred', msg: 'Please select at least one broker', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      this.hideAssignbtn = false;
    }
  }
  onChange(list, event) {
    // Whenever we are updating the primary broker we will be having two scenarios
    // 1. If the broker is previous and the primary broker have changed then we will keep U status (U -> Update)
    //2. If the broker is new and primary then we will be using I status (I -> Insert)
    //3. All the previous brokers will be in E status (E -> Existing)

    this.validationMsg = false;
    this.ExchangeInvitesList.forEach(item => {
      var index = this.ExchangeInvitesList.indexOf(item);
      if (item.Id != list.Id && item.IsPrimaryAgent) {
        item.IsPrimaryAgent = false;
      }
      if (item.Id == list.Id && item.IsExistingBroker != "I") {
        this.ExchangeInvitesList[index].IsExistingBroker = "U";
      }
      else if (item.IsExistingBroker != "I") {
        this.ExchangeInvitesList[index].IsExistingBroker = "E";
      }
    });
  }

  removeBrokerLst(invitee) {
    var index = this.ExchangeInvitesList.indexOf(invitee);
    this.ExchangeInvitesList.splice(index, 1);
    var invIndex = this.brokers.indexOf(invitee);
    if (invIndex <= 0) {
      this.broker.id = invitee.Id;
      this.broker.name = invitee.Name;
      this.brokers.push(this.broker);
      this.brokers = [...this.brokers]; // For forcefull refresh of the model
      invitee.IsPrimaryAgent = false;
      this.brokerlist.push(invitee);
    }
  }

  saveBrokerDetails() {
    var primaryBrokerExist = this.ExchangeInvitesList.find(x => x.IsPrimaryAgent == true);
    if (primaryBrokerExist != null) {
      this._Trade1031Service.saveBrokerDetails(this.ExchangeInvitesList, this.currentExchangeid, this.user.Id).subscribe(response => {
        if (response) {
          this.reloadList();
        }
        else {
          this.Toast.addToast({
            title: 'Error', msg:
              'Error while updating broker details', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          });
        }
      });
    }
    else {
      this.validationMsg = true;
    }

  }

  onTabClick(tab) {
    this.IsLoading = true;
    this.activeTab = tab;
    //this.router.navigateByUrl(this.Validation.changeQueryStringValue('activetab', tab));
    this.dtElement.dtInstance.then(x => x.draw());
    //this.loadExchangeList();

  }


}

